import * as React from 'react';
import PropsChecker from '@core-front/props-checker';
function getInitialValue(type, defaultValue) {
    if (defaultValue) {
        return defaultValue;
    }
    else if (type === 'check') {
        return [];
    }
    else {
        return null;
    }
}
function BEM(props) {
    const { display, align, hideLabel, purpose, isInvalid, className } = props;
    const classArray = ['choice-group'];
    if (display) {
        classArray.push('choice-group--' + display);
    }
    if (align) {
        classArray.push('choice-group--' + align);
    }
    if (hideLabel) {
        classArray.push(hideLabel === true ? 'choice-group--no-label-no-break' : 'choice-group--no-label-' + hideLabel);
    }
    if (purpose) {
        classArray.push('choice-group--purpose-' + purpose);
    }
    if (isInvalid) {
        classArray.push('is-invalid');
    }
    if (className) {
        classArray.push(className);
    }
    return classArray.join(' ');
}
function labelBEM(props) {
    const { labelClass } = props;
    const classArray = ['choice-group__label'];
    if (labelClass) {
        classArray.push(labelClass);
    }
    return classArray.join(' ');
}
function innerBEM(props) {
    const { innerColorClass } = props;
    const classArray = ['choice-group__inner'];
    if (innerColorClass) {
        classArray.push(innerColorClass);
    }
    else {
        classArray.push('choice-group__inner--default-background');
    }
    return classArray.join(' ');
}
const ChoiceGroupCore = (props) => {
    return (React.createElement(PropsChecker, { componentName: "ChoiceGroup", componentProps: props, defaultValueName: "defaultValue", valueName: "value", onChangeNames: "onChange" },
        React.createElement(ChoiceGroupCoreInner, Object.assign({}, props))));
};
const ChoiceGroupCoreInner = (props) => {
    const { Check, FormHelper, Radio } = props.components;
    const [innerValue, setInnerValue] = React.useState(getInitialValue(props.type, props.defaultValue));
    const currentValue = props.onChange && typeof props.value !== 'undefined' ? props.value : innerValue;
    const isInvalid = props.isInvalid || !!props.helper && props.helper.type === 'error';
    function getNextValue(value, checked) {
        if (props.type === 'check' && Array.isArray(currentValue)) {
            if (checked) {
                return [...currentValue, value];
            }
            else {
                return currentValue.filter((item) => item !== value);
            }
        }
        else {
            return value;
        }
    }
    function onChange(value, checked, onChange) {
        if (typeof props.value === 'undefined') {
            setInnerValue(getNextValue(value, checked));
        }
        if (props.onChange) {
            props.onChange(getNextValue(value, checked));
        }
        if (onChange) {
            onChange(checked);
        }
    }
    function isChecked(value) {
        if (currentValue === null) {
            return false;
        }
        if (props.type === 'check') {
            return value === currentValue || currentValue.indexOf(value) !== -1;
        }
        else {
            return value === currentValue;
        }
    }
    function getChildren() {
        if (props.children) {
            // since Radio and Check can have children, ChoiceGroup must allow children as well.
            return React.Children.toArray(props.children).filter((child) => {
                return React.isValidElement(child) && (child.type === Check || child.type === Radio);
            }).map((child) => {
                const { props: childProps } = child;
                /* istanbul ignore if */
                if ('skeleton' in childProps) {
                    return child;
                }
                return React.cloneElement(child, {
                    'key': childProps.id,
                    'checked': isChecked(childProps.value),
                    'className': ['choice-group__item', childProps.className].join(' '),
                    'onChange': (checked) => onChange(childProps.value, checked, childProps.onChange),
                    'aria-invalid': isInvalid,
                    'aria-describedby': props.helper ? (props.helper.id || `${props.id}-helper`) : undefined,
                });
            });
        }
        if (!props.options) {
            return [];
        }
        return props.options.map((item) => {
            const ariaDescribedBy = props.helper ? (props.helper.id || `${props.id}-helper`) : undefined;
            if (props.type === 'check') {
                /* istanbul ignore if */
                if ('skeleton' in item) {
                    return (React.createElement(Check, Object.assign({}, item, { key: item.id, className: "choice-group__item", "aria-invalid": isInvalid, "aria-describedby": ariaDescribedBy })));
                }
                return (React.createElement(Check, Object.assign({}, item, { checked: isChecked(item.value), onChange: (checked) => onChange(item.value, checked, item.onChange), key: item.id, className: "choice-group__item", "aria-invalid": isInvalid, "aria-describedby": ariaDescribedBy })));
            }
            /* istanbul ignore if */
            if ('skeleton' in item) {
                return (React.createElement(Radio, Object.assign({}, item, { key: item.id, className: "choice-group__item", "aria-invalid": isInvalid, "aria-describedby": ariaDescribedBy })));
            }
            return (React.createElement(Radio, Object.assign({}, item, { checked: isChecked(item.value), onChange: (checked) => onChange(item.value, checked, item.onChange), key: item.id, className: "choice-group__item", "aria-invalid": isInvalid, "aria-describedby": ariaDescribedBy })));
        });
    }
    return (React.createElement("fieldset", { className: BEM(props), id: props.id },
        React.createElement("legend", { className: labelBEM(props) }, props.label),
        React.createElement("div", { className: innerBEM(props) }, getChildren()),
        props.helper && (React.createElement(FormHelper, Object.assign({}, props.helper, { className: "choice-group__form-helper", id: props.helper.id || `${props.id}-helper` })))));
};
export { ChoiceGroupCore as default, };
